export default __webpack_public_path__ + "static/REDA-LOGO-de55c6f737a243997622d7c0a26168ab.jpg";